<script>
    import {Tween} from 'svelte/motion';
    import {cubicOut} from 'svelte/easing';

    import {ElevationRideTypes} from '@js/components/modules/constants';
    import I18n from '@js/modules/translations';
    import Computation from '@js/modules/computation';

    import {userStore} from '@js/stores/userStore';
    import {mapStore} from '@js/stores/mapStore';

    const distanceProgress = new Tween(mapStore.currentDistance, {
        duration: 800,
        easing: cubicOut
    });

    const durationProgress = new Tween(mapStore.currentDuration, {
        duration: 800,
        easing: cubicOut
    });

    $effect(() => {
        distanceProgress.target = $mapStore.currentDistance;
    });
    $effect(() => {
        durationProgress.target = $mapStore.currentDuration;
    });
</script>

<div class="map-data-outline">
    <div class="outline-container">
        <div class="outline-data">
            <div class="outline-value"
                 class:outline-value-on={$mapStore.currentDistance}>
                {Computation.formatDistance(distanceProgress.current, {
                    unit: $userStore.unit,
                    smartUnit: true,
                    kUnit: false
                })}
            </div>

            <div class="outline-name">
                {I18n.t('js.maps.outline.distance')}
            </div>
        </div>

        <div class="outline-data">
            <div class="outline-value">
                {Computation.formatDuration(durationProgress.current, {withLeadingZero: false}) || '-'}
            </div>

            <div class="outline-name">
                {I18n.t('js.maps.outline.duration')}
            </div>
        </div>

        {#if ElevationRideTypes.includes($mapStore.currentRideType)}
            <div class="outline-data outline-data-optional">
                <div class="outline-value">
                    {`${Computation.formatDistance($mapStore.elevationApsis.minimumAltitude, {
                        smartUnit: false,
                        kUnit: false
                    }) || '-'} / ${Computation.formatDistance($mapStore.elevationApsis.maximumAltitude, {
                        smartUnit: false,
                        kUnit: false
                    }) || '-'}`}
                </div>

                <div class="outline-name">
                    {I18n.t('js.maps.outline.elevation_apsis')}
                </div>
            </div>

            {#if $mapStore.currentLevel}
                <div class="outline-data outline-data-optional">
                    <div class="outline-value">
                        {I18n.t(`js.ride.enums.level.${$mapStore.currentLevel}`)}
                    </div>

                    <div class="outline-name">
                        {I18n.t('js.maps.outline.level')}
                    </div>
                </div>
            {/if}
        {/if}
    </div>
</div>
